import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { canAccess, homeFor } from "@/lib/roles";

export default function ProtectedRoute({ allowedRoles, children }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="flex items-center justify-center min-h-screen" data-testid="auth-loading">
                <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    const role = user.role;
    if (allowedRoles && !allowedRoles.includes(role)) {
        return <Navigate to={homeFor(role)} replace />;
    }
    if (!canAccess(role, location.pathname)) {
        return <Navigate to={homeFor(role)} replace />;
    }
    return children;
}
